
import React from "react";
import { ArrowRight, Globe } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { useNavigate } from "react-router-dom";
import { QuickEnquiry } from "./QuickEnquiry";
import { analytics } from "@/lib/analytics";

interface CardActionsProps {
  countySlug: string;
  nhSlug: string;
  centerName: string;
  websiteUrl?: string;
  onTrackClick: (type: string) => void;
  isInLeads: boolean;
  setIsInLeads: (value: boolean) => void;
  email?: string;
}

export function CardActions({
  countySlug,
  nhSlug,
  centerName,
  websiteUrl,
  onTrackClick,
}: CardActionsProps) {
  const navigate = useNavigate();
  
  const handleViewDetails = () => {
    onTrackClick('view_details');
    analytics.viewDetails(nhSlug, centerName, 'card');
    navigate(`/nursing-homes/${countySlug}/${nhSlug}`);
  };
  
  return (
    <div className="flex flex-col gap-2">
      {/* Row 1: View Details + Website */}
      <div className="flex gap-2">
        <Button 
          variant="default" 
          onClick={handleViewDetails}
          className="flex-1 bg-grandpal-green-dark"
        >
          View Details
          <ArrowRight className="h-4 w-4 ml-1" />
        </Button>
        
        {websiteUrl && (
          <TooltipProvider>
            <Tooltip>
              <TooltipTrigger asChild>
                <Button 
                  variant="outline" 
                  size="icon" 
                  onClick={() => {
                    onTrackClick('website');
                    analytics.websiteClick(nhSlug, centerName, 'card');
                    window.open(websiteUrl, '_blank');
                  }}
                  aria-label={`Visit ${centerName} website`}
                >
                  <Globe className="h-4 w-4" />
                </Button>
              </TooltipTrigger>
              <TooltipContent>Visit website</TooltipContent>
            </Tooltip>
          </TooltipProvider>
        )}
      </div>

      {/* Row 2: Quick Enquiry */}
      <QuickEnquiry
        nursingHomeId={nhSlug}
        nursingHomeName={centerName}
        county={countySlug}
        source="card"
      />
    </div>
  );
}
